import React from "react";
import s from "../labReportPdf.module.scss";

const titers = ["1:40", "1:80", "1:160", "1:320"];

const parseTiterValues = (value) => {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim()) {
    try {
      const parsed = JSON.parse(value);

      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed;
      }
    } catch {
      return {};
    }
  }

  return {};
};

const WidalReportPdf = ({ profile, PageBaseLayout, PageFooter }) => {
  const tests = profile?.tests || [];

  const impression = profile?.comment || profile?.impression || "";

  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout
        showSampleType={true}
        currentSampleType={profile?.sampleType}
      />

      <div className={s.testCategoryHeader}>
        {(profile?.profileName || "Widal (Slide Method)").toUpperCase()}
      </div>

      <table className={s.resultsTable}>
        <thead>
          <tr>
            <th style={{ width: "30%" }}>Test Description</th>

            {titers.map((titer) => (
              <th key={titer} style={{ textAlign: "center" }}>
                {titer}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {/* Section heading */}
          {/* <tr>
            <td
              colSpan={5}
              style={{
                textAlign: "center",
                fontWeight: "600",
                padding: "10px",
              }}
            >
              SEROLOGY
            </td>
          </tr> */}

          {/* Titer headers */}
          {/* <tr>
            <td style={{ fontWeight: "600" }}>Antigen</td>

            {titers.map((titer) => (
              <td
                key={titer}
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                {titer}
              </td>
            ))}
          </tr> */}

          {/* Test results */}
          {tests.map((test, index) => {
            const values = parseTiterValues(test?.value);

            return (
              <tr key={test?.id || test?._id || index}>
                <td style={{ fontWeight: "500" }}>
                  {test?.testName || test?.name || ""}
                </td>

                {titers.map((titer) => (
                  <td
                    key={titer}
                    style={{
                      textAlign: "center",
                      padding: "8px 4px",
                    }}
                  >
                    {values[titer] || "-"}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Impression */}
      <div
        style={{
          marginTop: "24px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            fontWeight: "600",
            marginBottom: "8px",
          }}
        >
          Impression:
        </div>

        <div
          style={{
            minHeight: "45px",
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
            fontSize: "13px",
          }}
        >
          {impression}
        </div>
      </div>

      <PageFooter />
    </div>
  );
};

export default WidalReportPdf;
